import { ArrowRight } from "lucide-react";
import Logo from "@/components/Logo";

const scrollTo = (e, id) => {
  e.preventDefault();
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Nav() {
  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-hairline bg-ivory/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 md:px-8">
        <a
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          data-testid="nav-logo"
          aria-label="DocketScout home"
        >
          <Logo />
        </a>
        <nav className="hidden items-center gap-8 text-[13px] font-semibold text-smoke md:flex">
          <a
            href="#how"
            onClick={(e) => scrollTo(e, "how")}
            data-testid="nav-link-how"
            className="transition-colors hover:text-ink"
          >
            How it works
          </a>
          <a
            href="#features"
            onClick={(e) => scrollTo(e, "features")}
            data-testid="nav-link-features"
            className="transition-colors hover:text-ink"
          >
            Features
          </a>
          <a
            href="#developers"
            onClick={(e) => scrollTo(e, "developers")}
            data-testid="nav-link-developers"
            className="transition-colors hover:text-ink"
          >
            Developers
          </a>
        </nav>
        <button
          onClick={(e) => scrollTo(e, "search-console")}
          data-testid="nav-cta"
          className="group inline-flex items-center gap-2 rounded-md bg-ink px-4 py-2 text-[13px] font-semibold text-ivory transition-colors duration-300 hover:bg-crimson"
        >
          Run a search
          <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5" />
        </button>
      </div>
    </header>
  );
}
